import { catchError, finalize, tap, throwError } from 'rxjs';

import { AuthService } from './auth-service';
import { HttpInterceptorFn } from '@angular/common/http';
import { LoaderService } from './loader-service';
import { ToastService } from './toast-service';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';

let pendingRequests = 0;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastService);
  const loaderService = inject(LoaderService);
  let token = authService.isLoggedIn() ? sessionStorage.getItem('token') : null;
  let xKey = authService.isLoggedIn() ? sessionStorage.getItem('xKey') : null;
  let twoFA = authService.isLoggedIn() ? sessionStorage.getItem('twoFA') : null;

  if (environment.setHeaderToken && token) {
    const headers: Record<string, string> = {
      'X-TOKEN': `${token}`,
      'X-KEY': `${xKey}`,
      'Content-Type': 'application/json',
    };
    if (twoFA) {
      headers['X-2FA'] = `${twoFA}`;
    }
    req = req.clone({
      setHeaders: headers
    });
  }

  pendingRequests++;
  loaderService.show();

  return next(req).pipe(
    tap({
      next: () => { },
      error: (error) => {
        console.log(error)
        if (error.status == '404') {
          toastService.showError(error.error?.message || 'Unauthorized access');
          // window.location.href = 'no-record-found';
        } else if (error.status == '401') {
          toastService.showError('Session expired');
          window.location.href = 'user/unauthorized';
        } else {
          let errorMessage = error.error?.message || error.message || 'Something went wrong!';
          toastService.showError(errorMessage);
        }
      }
    }),
    catchError((error) => throwError(() => error)),
    finalize(() => {
      pendingRequests--;
      if (pendingRequests === 0) {
        loaderService.hide();
      }
    })
  );
};
